// import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";

const DrDeepakBhuktarContent = () => {
  return (
    <>
      <Header />
      <div style={{ backgroundColor: "#fff9ee", padding: "40px 20px", paddingTop: "120px" }}>
        <div
          className="doctor-intro-container"
          style={{
            maxWidth: "1100px",
            margin: "auto",
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            alignItems: "flex-start",
            gap: "32px",
            textAlign: "left",
          }}
        >
          <img
            src="/Doctorprofile.png"
            alt="Dr. Deepak Bhuktar"
            style={{
              width: "220px",
              height: "220px",
              borderRadius: "50%",
              objectFit: "cover",
              border: "3px solid #ddd",
              flexShrink: 0,
            }}
          />

          <div
            className="vertical-divider"
            style={{
              width: "2px",
              backgroundColor: "#ccc",
              height: "100%",
              minHeight: "160px",
              display: "none",
            }}
          ></div>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "16px",
              flex: 1,
              minWidth: "260px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "16px",
              }}
              className="content-container"
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "16px",
                }}
                className="inner-content"
              >
                <div style={{ flex: 1 }}>
                  <h2 style={{ fontWeight: "bold", marginBottom: "8px" }}>
                    Dr. Deepak Bhuktar
                  </h2>
                  <p style={{ margin: "4px 0", color: "#333" }}>
                    <strong>Specialization:</strong> Your Health & Happiness Cheerleader
                  </p>
                  <p style={{ margin: "4px 0", color: "#333" }}>
                    <strong>Experience:</strong> 15 Years
                  </p>
                  <p style={{ margin: "4px 0", color: "#333" }}>
                    <strong>Degrees:</strong> MBBS, MD (Internal Medicine) from KEM Hospital Mumbai
                  </p>
                </div>

                <div
                  className="vertical-divider"
                  style={{
                    width: "2px",
                    backgroundColor: "#ccc",
                    height: "100%",
                    minHeight: "160px",
                    display: "none",
                  }}
                ></div>

                <div style={{ flex: 1 }}>
                  <p
                    style={{
                      fontStyle: "italic",
                      fontSize: "15px",
                      lineHeight: "1.6",
                      color: "#444",
                      marginTop: "4px",
                    }}
                  >
                    "Pregnancy is a celebration of what your body can do! Let's work together to make it an active, joyful, and incredibly empowering experience for you."
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style>
        {`
          @media (min-width: 768px) {
            .vertical-divider {
              display: block !important;
            }
      
            .inner-content {
              flex-direction: row !important;
            }
          }
      
          @media (max-width: 767px) {
            .doctor-intro-container {
              flex-direction: column;
              align-items: center !important;
              text-align: center !important;
            }
      
            .inner-content {
              flex-direction: column !important;
              align-items: center !important;
              text-align: center !important;
            }
      
            .content-container {
              align-items: center !important;
              text-align: center !important;
            }
          }
        `}
      </style>


      <div style={{ padding: "40px 20px", maxWidth: "1100px", margin: "auto" }}>
        <h3>My Philosophy on Pregnancy Care:</h3>
        <p style={{ marginTop: "12px", lineHeight: "1.6", color: "#444" }}>
          I believe in celebrating pregnancy! My energy is focused on proactive health—good nutrition, safe physical activity, and a positive mindset. I am your cheerleader, motivating you to be an active participant in your health. We will set goals together and I will be there to encourage you every step of the way, ensuring both you and your baby are as strong and healthy as possible.
        </p>

        <h3 style={{ marginTop: "32px" }}>Why I Chose Myprega:</h3>
        <p style={{ marginTop: "12px", lineHeight: "1.6", color: "#444" }}>
          The proactive, forward-thinking approach of Myprega is what drew me in. They don't just wait for problems to arise. The app, the educational content, the regular check-ins—it's all designed to build positive momentum. This perfectly matches my philosophy of building a foundation of health and happiness from day one.
        </p>

        <h3 style={{ marginTop: "32px" }}>Beyond the Clinic:</h3>
        <p style={{ marginTop: "12px", lineHeight: "1.6", color: "#444" }}>
          I am an avid runner and have completed several half-marathons. The discipline and resilience from running translate directly into my work. I love trying new cuisines and believe that healthy food can and should be delicious. My go-to book for inspiration is "Atomic Habits" by James Clear.
        </p>
      </div>

      <div style={{ backgroundColor: "#f9f7f2", padding: "40px 20px" }}>
        <div
          className="doctor-intro-container"
          style={{
            maxWidth: "1100px",
            margin: "auto",
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
            alignItems: "flex-start",
            gap: "24px",
            paddingTop: "32px",
          }}
        >
          {/* Favourite Book */}
          <div style={{ flex: 1, minWidth: "250px" }}>
            <p style={{ fontWeight: "bold", marginBottom: "4px" }}>
              📖 Favourite Book
            </p>
            <p style={{ color: "#333" }}>Atomic Habits by James Clear</p>
          </div>

          {/* Divider */}
          <div
            className="vertical-divider"
            style={{
              width: "1px",
              backgroundColor: "#ccc",
              height: "auto",
              minHeight: "50px",
              alignSelf: "stretch",
              display: "none",
            }}
          ></div>

          {/* Favourite Singer */}
          <div style={{ flex: 1, minWidth: "250px" }}>
            <p style={{ fontWeight: "bold", marginBottom: "4px" }}>
              🎵 Favourite Singer
            </p>
            <p style={{ color: "#333" }}>Arijit Singh</p>
          </div>

          {/* Divider */}
          <div
            className="vertical-divider"
            style={{
              width: "1px",
              backgroundColor: "#ccc",
              height: "auto",
              minHeight: "50px",
              alignSelf: "stretch",
              display: "none",
            }}
          ></div>

          {/* Favourite Pastime */}
          <div style={{ flex: 1, minWidth: "250px" }}>
            <p style={{ fontWeight: "bold", marginBottom: "4px" }}>
              🏃 Favourite Pastime
            </p>
            <p style={{ color: "#333" }}>
              Long-distance running <br />
              Exploring new healthy cuisines
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default DrDeepakBhuktarContent;
